import { render } from "./ErrorBox.vue?vue&type=template&id=e0c6d478"
const script = {}

import "./ErrorBox.vue?vue&type=style&index=0&id=e0c6d478&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.1_vue@3.2.13_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__